import { render } from "./ResultColumnWithArrow.vue?vue&type=template&id=1770e846"
import script from "./ResultColumnWithArrow.vue?vue&type=script&lang=js"
export * from "./ResultColumnWithArrow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__